import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/siteData";
import { imgUrl } from "@/lib/api";
import { ChapterHeading, Em, Reveal } from "./primitives";

export default function Testimonials({ content }) {
  const c = content || {};
  const items = c.items?.length ? c.items : TESTIMONIALS;

  return (
    <section id="reviews" className="py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <ChapterHeading
          number={(c.kicker || "05 — Words of Love").split("—")[0].trim()}
          kicker={(c.kicker || "05 — Words of Love").split("—")[1]?.trim() || "Words of Love"}
          title={<Em text={c.title || "What Our *Gifters* Say"} />}
          blurb={c.blurb || "Real notes from real customers whose moments we had the honour of wrapping."}
        />
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {items.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.08}>
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className="flex h-full flex-col gap-5 rounded-3xl border border-line bg-white p-7 transition-shadow duration-500 hover:shadow-xl hover:shadow-rose/10"
              >
                <div
                  className="flex gap-1"
                  aria-label={`${t.rating || 5} out of 5 stars`}
                >
                  {Array.from({ length: t.rating || 5 }).map((_, s) => (
                    <Star key={s} size={15} className="fill-gold text-gold" />
                  ))}
                </div>
                <blockquote className="font-serif text-lg italic leading-relaxed text-ink/85">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-2">
                  {t.image && (
                    <img
                      data-testid={`testimonial-photo-${i + 1}`}
                      src={imgUrl(t.image)}
                      alt={t.name}
                      loading="lazy"
                      className="h-10 w-10 shrink-0 rounded-full border border-line object-cover"
                    />
                  )}
                  <div>
                    <p className="text-xs font-bold uppercase tracking-[0.2em] text-ink">
                      {t.name}
                    </p>
                    <p className="mt-1 text-xs text-[#5C5C5C]">
                      {t.context} · {t.city}
                    </p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
